import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@/lib/theme';

type ToasterProps = React.ComponentProps<typeof Sonner>;

// shadcn's sonner wrapper, using this app's ThemeProvider instead of next-themes.
function Toaster(props: ToasterProps): JSX.Element {
  const { theme } = useTheme();
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:rounded-lg group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:bg-card group-[.toaster]:text-sm group-[.toaster]:text-foreground group-[.toaster]:shadow-xl',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton: 'group-[.toast]:border-border group-[.toast]:bg-card group-[.toast]:text-muted-foreground',
          // Card-look toasts (richColors removed): only the icon carries the status colour.
          success: '[&_[data-icon]]:text-success-fg',
          error: '[&_[data-icon]]:text-danger-fg',
          warning: '[&_[data-icon]]:text-warning-fg',
          info: '[&_[data-icon]]:text-info-fg',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
